const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v2/profile`;

export const getProfileService = async (token) => {
  try {
    const response = await fetch(`${API_URL}/query/complete/user`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // Enviamos el token para autenticar la petición
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Error ${response.status}: No se pudo obtener el perfil del usuario`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error en getProfileService:", error);
    throw error;
  }
};